import { Picture } from 'ui-kit/picture'
import { Link } from 'ui-kit/actions/link/Link'
import { LINKS } from 'routes/constants'
import { UniversalIntegrationsContent } from '../Content'
import { contentData } from '../Content/contentData'
import ApplyDesk1x from './apply-desk@1x.png'
import ApplyDesk2x from './apply-desk@2x.png'
import ApplyMob1x from './apply-mob@1x.png'
import ApplyMob2x from './apply-mob@2x.png'
import classes from './UniversalIntegrationsApply.module.scss'

export const UniversalIntegrationsApply = () => {
  return (
    <section className={classes.section}>
      <div className={classes.wrapper}>
        <UniversalIntegrationsContent item={contentData[1]}>
          Our{' '}
          <Link
            href={LINKS.INTEGRATIONS}
            type={'lineGradient'}
            target={'_blank'}
          >
            pre-built connectors
          </Link>{' '}
          and AI will map your universal integrations to application-specific
          API requests and mappings.
        </UniversalIntegrationsContent>
        <Picture
          className={classes.image}
          mobSrc1x={ApplyMob1x.src}
          mobSrc2x={ApplyMob2x.src}
          deskSrc1x={ApplyDesk1x.src}
          deskSrc2x={ApplyDesk2x.src}
          width={390}
          height={883}
          alt='Apply universal integration to all the relevant apps'
          lazyLoad
        />
      </div>
    </section>
  )
}
